<template>
  <div class="py-1 px-1" :class="{ 'border-t border-n-weak': showBorder }">
    <div 
      class="flex transition-colors rounded-lg p-3 bg-n-solid-1 hover:bg-n-slate-3"
      :class="[
        clickable ? 'items-center cursor-pointer' : 'items-start',
        !clickable && multiline ? 'items-start' : 'items-center'
      ]"
      @click="handleClick"
    >
      <!-- Icon -->
      <div 
        class="w-6 text-slate-500 dark:text-slate-400 text-center mr-3"
        :class="{ 'mt-0.5': !clickable && multiline }"
      >
        <span :class="icon" />
      </div>

      <!-- Title and Value -->
      <div class="flex-grow">
        <div class="text-xs text-slate-500 dark:text-slate-400 mb-1">
          {{ label }}
        </div>
        <div 
          class="text-sm font-medium text-slate-700 dark:text-slate-200"
          :class="{ 'whitespace-pre-wrap': multiline }"
        >
          <slot>
            <span v-if="htmlContent" v-html="value" />
            <span v-else>{{ value }}</span>
          </slot>
        </div>
      </div>

      <!-- Copy Button -->
      <div v-if="copyable" class="flex items-center">
        <button
          @click.stop="handleCopy"
          class="text-slate-500 dark:text-slate-400 hover:text-slate-700 dark:hover:text-slate-200 transition-colors"
          title="Copiar"
        >
          <span class="i-lucide-copy text-sm" />
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ContactInfoItem',
  props: {
    label: {
      type: String,
      required: true,
    },
    icon: {
      type: String,
      required: true,
    },
    value: {
      type: String,
      default: '',
    },
    showBorder: {
      type: Boolean,
      default: true,
    },
    clickable: {
      type: Boolean,
      default: false,
    },
    copyable: {
      type: Boolean,
      default: false,
    },
    multiline: {
      type: Boolean,
      default: false,
    },
    htmlContent: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['click', 'copy'],
  methods: {
    handleClick() {
      if (this.clickable) {
        this.$emit('click');
      }
    },
    handleCopy() {
      if (this.copyable && this.value) {
        this.$emit('copy', this.value);
      }
    },
  },
};
</script>